import { render } from "./WarningBox.vue?vue&type=template&id=6fcd0031&scoped=true"
import script from "./WarningBox.vue?vue&type=script&lang=js"
export * from "./WarningBox.vue?vue&type=script&lang=js"

import "./WarningBox.vue?vue&type=style&index=0&id=6fcd0031&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fcd0031"]])

export default __exports__